import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './examples.scss';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class Resource extends React.Component{
	constructor (props) {
		super(props)
		this.state={

		}
	}
    componentDidMount (){
        document.getElementById('app').scrollIntoView(true)
    }
	render() {
		return(
			<div className='weidai'>
				<div className='common-head home-contain'>
					<a href='#/customer' className="mianbaoxie">客户案例</a> <i className='glyphicon glyphicon-toright'></i> <span>19楼</span>
				</div>
				<div className='common-title' style={{marginBottom: '24px'}}>十九楼网络股份有限公司</div>
				<div className='home-contain text-contain'>
					<span className='special'>推广产品名称：</span>
					<span>19楼婚博会，19楼家博会</span>
					<span className='special'>推广主题文案：</span>
					<span className='special'>1，要结婚，就上19楼！</span>
					<span>2，找装修，买建材，购家电，淘家具就上19楼！</span>
					<span className='special'>推广平台：</span>
					<span>360搜索，360展示广告</span>
					<span className='special'>广告类型：</span>
					<span>信息流、互动广告、360导航开屏</span>
					<span className='special'>客户需求：</span>
					<span>获得目标客户报名参与19楼家博会/婚博会活动</span>
					<span className='special'>投放方案：</span>
					<span className='special'>1，360搜索端投放品牌词，产品词，行业词，结合凤舞多种样式组合展现，直击客户需求，引导潜在客户报名参与19楼活动；</span>
					<span className='special'>2，在360展示广告投放360导航开屏，信息流等优质资源，精准定向客户兴趣人群，关键词人群，网站访客人群，将客户活动优惠信息强势曝光，快速传</span>
					<span>递给目标客群，从而实现目标客户报名参加19楼婚博会。</span>
					<span className='special'>效果数据：</span>
					<span>新增用户增长300%</span>
					<span className='special'>投放总结：</span>
					<span className='special'>利用360搜索关键词投放，覆盖潜在需求客户人群，引导新老客户直接搜索并报名参与活动；利用360展示广告，投放信息流，开屏，互动广告等多种样式</span>
					<span>广告，并且定向人群投放，强曝光，吸引用户关注和报名，达到客户活动推广目的；</span>
					<span className='special'>客户评价：</span>
					<span>用户高度匹配行业需求，投放精准，直达潜在用户，转化效果较好，广告位置清晰醒目，服务团队专业细致，愿意长期合作。</span>
				</div>
				<div className='common-title'>效果展示</div>
				<div className='home-contain text-contain' style={{paddingBottom: '50px'}}>
					<div className='text-center'>
						<div>
							<img style={{display: 'inline-block'}} src={`${process.env.PUBLIC_URL}/images/hudong1.png`} />
							<i className='glyphicon-goRight glyphicon' style={{fontSize: '26px', margin: '0 60px'}}></i>
							<img style={{display: 'inline-block'}} src={`${process.env.PUBLIC_URL}/images/hudong2.png`} />
						</div>
					</div>
					<span className='second-title text-center'>互动广告</span>
					<div className='text-center' style={{position: 'relative'}}>
						<img className='block-center' src={`${process.env.PUBLIC_URL}/images/xinxi1.png`} />
					</div>
					<span className='second-title text-center'>信息流广告</span>
					<div className='text-center' style={{position: 'relative'}}>
						<img className='block-center' src={`${process.env.PUBLIC_URL}/images/xinxi2.png`} />
					</div>
					<span className='second-title text-center'>360导航开屏</span>
				</div>
			</div>
		)
	}
}
export default Resource;



// WEBPACK FOOTER //
// ./src/components/examples/19lou.jsx